import { render, staticRenderFns } from "./CmgApp.vue?vue&type=template&id=0a3971f7&lang=pug&"
import script from "./cmg-app.ts?vue&type=script&lang=ts&"
export * from "./cmg-app.ts?vue&type=script&lang=ts&"
import style0 from "./CmgApp.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CmgApp.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports